/**
 * downloadFile — save a file to the user's disk with its real filename.
 *
 * Result files live on signed GCS URLs (cross-origin), where the `download` attribute on an <a> is
 * ignored, so the file is fetched as a blob first (the same approach MediaViewerHeader has used since
 * the viewer shipped). If the fetch fails (CORS, network), the URL opens in a new tab so the user can
 * still save it from there. Used by every SHOW_FILE render in chat (FileTile, inline images) since
 * Sep 19 2026 (Nitish: a right-click "Save video as" is not obvious to non-developers).
 *
 * @param {string} url       The file URL (signed GCS URL or any https URL).
 * @param {string} filename  The name to save as.
 */
export async function downloadFile(url, filename) {
  if (!url) return;
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
  } catch (e) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export default downloadFile;
